import axios from 'axios';
import Config from '../../misc/Config';
import Auth  from '../../misc/Auth';

const OFFER_URL = Config.PROXY_URL + '/offers';
const TRAINER_URL = Config.PROXY_URL + '/trainers';
const COMPANY_URL = Config.PROXY_URL + '/companies';
const SEMINAR_URL = Config.PROXY_URL + '/seminars';


const state = {
    
    offer: null,
    sections: [],
    combitData: null
};
const getters = {
    offer: (state) => state.offer,
    offerSections: (state) => state.sections,
};
const actions = {
    async proxyFetchOffer({ commit, dispatch }, hash) {
        const response = await axios.get(OFFER_URL + '/by-hash/' + hash);
        commit('setOffer', response.data);
        commit('setSeminar', response.data.seminar);
        commit('setContact', response.data.contact);
        commit('setCompany', response.data.contact.company)
        commit('setTrainer', response.data.trainer);
        commit('setEmployee', response.data.employee);
        commit('setOfferType', response.data.offerType);
        commit('setOfferSections', response.data.sections);
        if(response.data.trainer && response.data.trainer.ref_id){
            dispatch('proxyFetchTrainerRating', state.offer.trainer.ref_id);
            dispatch('proxyFetchTrainerTopics', {
                trainerId: response.data.trainer.ref_id,
                seminarId: response.data.seminar.ref_id
            });
        }
        dispatch('proxyFetchCompanyRating', state.offer.contact.company.ref_id);
        dispatch('proxyFetchSeminarRating', state.offer.seminar.ref_id);
    },
    async proxyAddLastViewed(_, hash) {
        if(Auth.isLoggedIn()) return;
        await axios.post(`${Config.PROXY_URL}/add-view/${hash}`, {}) //empty because post-data is only a timestamp which is better created serverside
            .catch(err => console.log('err', err));
    },
    async proxyFetchTrainerRating({ commit }, id) {
        const response = await axios.get(TRAINER_URL + '/' + id +'/top-reviews');
        commit('setTrainerRating', response.data);
    },
    async proxyFetchTrainerTopics({ commit }, ids) {
        const response = await axios.get(TRAINER_URL + '/' + ids.trainerId + '/topics/' + ids.seminarId);
        commit('setTopics', response.data);
    },
    async proxyFetchCompanyRating({ commit }, id) {
        const response = await axios.get(COMPANY_URL + '/' + id.split("_")[0] +'/top-reviews'); 
        commit('setCompanyRating', response.data);
    },
    async proxyFetchSeminarRating({ commit }, id) {
        const response = await axios.get(SEMINAR_URL + '/' + id +'/top-reviews'); 
        commit('setSeminarRating', response.data);
    },
};
const mutations = {
    setOffer: (state, offer) => state.offer = offer,
    setOfferSections: (state, sections) => state.sections = sections,
};

export default {
    state,
    getters,
    actions,
    mutations
}